var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyShipList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336.934,
    height: 225.433,
    viewBox: "0 0 336.934 225.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4251",
    "data-name": "Group 4251",
    transform: "translate(-412.202 -367.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4210",
    "data-name": "Group 4210",
    transform: "translate(412.202 437.609)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 146.933,
    cy: 32.933,
    rx: 146.933,
    ry: 32.933,
    transform: "translate(0 52.791)",
    fill: "#e7f8fd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 136.167,
    cy: 51.3,
    rx: 136.167,
    ry: 51.3,
    transform: "translate(64.6 52.791)",
    fill: "#e7f8fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168",
    transform: "translate(101.961 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M63.335,362.556l5.733-5.4,24.956-5.734,82.3,16.189-9.9,3.036Z",
    transform: "translate(-63.335 -351.425)",
    fill: "#c4cdfa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(24.276 3.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M27.126,385.188,94.58,432.4,279.4,435.552s9.444-24.732-.9-36.873l-4.495-15.739L131.9,353.26S103.125,359.1,97.277,364.5s-18.886,18.886-18.886,18.886Z",
    transform: "translate(-27.126 -353.26)",
    fill: "#c4cdfa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4170",
    "data-name": "Group 4170",
    transform: "translate(82.738 76.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M54.375,387.216l195.163,5.4-1.346,4.046L63.368,393.512Z",
    transform: "translate(-54.375 -387.216)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4171",
    "data-name": "Group 4171",
    transform: "translate(75.541 30.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M51.021,368.969a365.913,365.913,0,0,1,56.212,1.349c28.781,3.147,146.148,16.64,146.148,16.64l-2.248-2.7s-121.416-15.29-143.449-17.088S61.364,364.921,51.021,368.969Z",
    transform: "translate(-51.021 -365.848)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4172",
    "data-name": "Group 4172",
    transform: "translate(86.335 51.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M56.052,375.658a18.066,18.066,0,0,0,4.048,1.347c2.248.451,41.37,1.349,68.351,4.048S245.821,390.5,245.821,390.5s2.253-1.349-1.349-2.248S70.443,372.957,56.052,375.658Z",
    transform: "translate(-56.052 -375.321)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4173",
    "data-name": "Group 4173",
    transform: "translate(79.588 24.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M52.907,368.413l31.972-2.673,2.585-3.036-32.309,3.459Z",
    transform: "translate(-52.907 -362.704)",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4174",
    "data-name": "Group 4174",
    transform: "translate(84.253 10.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M55.081,370.9,66.3,369.549l4.8-5.621,14.393-1.349,1.238-2.024,9.893-.674,3.6-3.371-15.514,1.573-1.237,2.472-14.613,1.573-2.7,3.149-6.412.561Z",
    transform: "translate(-55.081 -356.509)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4175",
    "data-name": "Group 4175",
    transform: "translate(111.517 5.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M87.126,353.889l-2.7,7.643-6.743,4.048-1.8,3.6-4.5,1.349-.9,2.25-1.25,1.5-1.449,1.645,163.5,19.772-2.319-7.8-1.544-5.676Z",
    transform: "translate(-67.79 -353.889)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4176",
    "data-name": "Group 4176",
    transform: "translate(111.517 24.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M70.488,362.692l159.918,20.176.762,2.7L67.79,365.839Z",
    transform: "translate(-67.79 -362.692)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4177",
    "data-name": "Group 4177",
    transform: "translate(119.611 16.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M71.562,362.935l1.8-3.6,151.542,23.386.592,1.879Z",
    transform: "translate(-71.562 -359.338)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4178",
    "data-name": "Group 4178",
    transform: "translate(125.459 10.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M74.288,359.882l3.483-3.375,143,25.607.508,1.94Z",
    transform: "translate(-74.288 -356.507)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4179",
    "data-name": "Group 4179",
    transform: "translate(129.956 5.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M76.384,356.587l.9-2.7,74.083,13.837L217.606,382.2Z",
    transform: "translate(-76.384 -353.889)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4180",
    "data-name": "Group 4180",
    transform: "translate(96.901 42.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M68.4,372.931c0,1.026-1.661,1.856-3.707,1.856s-3.712-.83-3.712-1.856,1.663-1.856,3.712-1.856S68.4,371.907,68.4,372.931Z",
    transform: "translate(-60.977 -371.075)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4181",
    "data-name": "Group 4181",
    transform: "translate(111.404 42.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M75.158,373.01c0,1.025-1.663,1.854-3.712,1.854s-3.709-.828-3.709-1.854,1.661-1.856,3.709-1.856S75.158,371.986,75.158,373.01Z",
    transform: "translate(-67.737 -371.154)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4182",
    "data-name": "Group 4182",
    transform: "translate(123.211 42.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M80.652,373.34c-.045,1.019-1.742,1.774-3.789,1.684s-3.667-1-3.621-2.023,1.746-1.774,3.791-1.686S80.7,372.317,80.652,373.34Z",
    transform: "translate(-73.241 -371.308)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4183",
    "data-name": "Group 4183",
    transform: "translate(135.691 43.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M86.469,373.653c-.045,1.021-1.742,1.776-3.789,1.684s-3.669-1-3.621-2.023,1.744-1.774,3.789-1.684S86.514,372.632,86.469,373.653Z",
    transform: "translate(-79.058 -371.623)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4184",
    "data-name": "Group 4184",
    transform: "translate(146.822 44.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M91.659,373.967c-.047,1.021-1.744,1.776-3.793,1.686s-3.667-1-3.619-2.021,1.744-1.778,3.789-1.688S91.7,372.946,91.659,373.967Z",
    transform: "translate(-84.246 -371.937)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4185",
    "data-name": "Group 4185",
    transform: "translate(159.638 45.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5754",
    "data-name": "Path 5754",
    d: "M97.631,374.6c-.047,1.021-1.744,1.774-3.791,1.684s-3.667-1-3.619-2.025,1.742-1.774,3.787-1.684S97.678,373.573,97.631,374.6Z",
    transform: "translate(-90.22 -372.566)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4186",
    "data-name": "Group 4186",
    transform: "translate(172.116 46.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5755",
    "data-name": "Path 5755",
    d: "M103.447,375.067c-.045,1.026-1.744,1.776-3.789,1.688s-3.667-1-3.621-2.023,1.744-1.776,3.791-1.688S103.492,374.046,103.447,375.067Z",
    transform: "translate(-96.036 -373.037)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4187",
    "data-name": "Group 4187",
    transform: "translate(182.571 47.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M108.322,375.538c-.047,1.026-1.744,1.779-3.791,1.688s-3.669-1-3.621-2.025,1.744-1.774,3.791-1.684S108.369,374.514,108.322,375.538Z",
    transform: "translate(-100.909 -373.51)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4188",
    "data-name": "Group 4188",
    transform: "translate(193.699 48.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M113.511,376.012c-.047,1.021-1.746,1.776-3.791,1.688s-3.667-1-3.624-2.025,1.744-1.776,3.793-1.688S113.556,374.991,113.511,376.012Z",
    transform: "translate(-106.096 -373.98)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4189",
    "data-name": "Group 4189",
    transform: "translate(204.495 49.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M118.539,376.482c-.047,1.026-1.744,1.781-3.793,1.688s-3.664-1-3.617-2.023,1.742-1.776,3.789-1.688S118.586,375.461,118.539,376.482Z",
    transform: "translate(-111.128 -374.452)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4190",
    "data-name": "Group 4190",
    transform: "translate(215.621 50.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M123.729,377.111c-.047,1.026-1.742,1.776-3.791,1.688s-3.667-1-3.624-2.023,1.746-1.776,3.793-1.688S123.776,376.09,123.729,377.111Z",
    transform: "translate(-116.314 -375.081)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4191",
    "data-name": "Group 4191",
    transform: "translate(226.507 51.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M128.286,377.522c-.043.955-1.622,1.654-3.527,1.57s-3.413-.929-3.37-1.884,1.624-1.652,3.529-1.568S128.331,376.57,128.286,377.522Z",
    transform: "translate(-121.388 -375.634)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4192",
    "data-name": "Group 4192",
    transform: "translate(236.397 52.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M132.872,377.82c-.041.95-1.618,1.65-3.516,1.564s-3.4-.929-3.358-1.875,1.615-1.65,3.514-1.566S132.915,376.872,132.872,377.82Z",
    transform: "translate(-125.998 -375.936)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4193",
    "data-name": "Group 4193",
    transform: "translate(245.442 53.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M136.814,378.095c-.045.91-1.555,1.579-3.375,1.5s-3.265-.89-3.225-1.8,1.553-1.581,3.373-1.5S136.852,377.181,136.814,378.095Z",
    transform: "translate(-130.214 -376.286)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4194",
    "data-name": "Group 4194",
    transform: "translate(254.419 54.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5763",
    "data-name": "Path 5763",
    d: "M140.788,378.379c-.039.88-1.5,1.534-3.27,1.455s-3.16-.867-3.119-1.746,1.5-1.532,3.27-1.455S140.828,377.495,140.788,378.379Z",
    transform: "translate(-134.398 -376.626)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4195",
    "data-name": "Group 4195",
    transform: "translate(263.416 54.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5764",
    "data-name": "Path 5764",
    d: "M145.587,378.8c-.045.965-1.648,1.673-3.576,1.586s-3.461-.944-3.418-1.907,1.646-1.676,3.576-1.588S145.629,377.823,145.587,378.8Z",
    transform: "translate(-138.592 -376.879)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4196",
    "data-name": "Group 4196",
    transform: "translate(272.715 55.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5765",
    "data-name": "Path 5765",
    d: "M148.854,379.028c-.036.822-1.392,1.422-3.031,1.349s-2.933-.8-2.9-1.618,1.4-1.422,3.034-1.347S148.893,378.21,148.854,379.028Z",
    transform: "translate(-142.926 -377.406)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4197",
    "data-name": "Group 4197",
    transform: "translate(101.961 5.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5766",
    "data-name": "Path 5766",
    d: "M92.228,353.889,65.923,357.6l-2.588,2.137,28-3.147Z",
    transform: "translate(-63.335 -353.889)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4198",
    "data-name": "Group 4198",
    transform: "translate(165.704 24.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5767",
    "data-name": "Path 5767",
    d: "M94.621,362.64l-1.575,2.921,7.42,1.125,1.012-3.034Z",
    transform: "translate(-93.047 -362.64)",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4199",
    "data-name": "Group 4199",
    transform: "translate(199.881 29.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5768",
    "data-name": "Path 5768",
    d: "M109.652,365.051l-.675,2.47,14.5,2.137.675-2.361Z",
    transform: "translate(-108.977 -365.051)",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4200",
    "data-name": "Group 4200",
    transform: "translate(179.532 32.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5769",
    "data-name": "Path 5769",
    d: "M100.392,366.623l-.9,2.808,43.509,5.4.563-2.927Z",
    transform: "translate(-99.492 -366.623)",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4201",
    "data-name": "Group 4201",
    transform: "translate(250.245 41.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5770",
    "data-name": "Path 5770",
    d: "M133.016,370.762l-.564,2.359,22.709,2.812-.447-2.361Z",
    transform: "translate(-132.452 -370.762)",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4202",
    "data-name": "Group 4202",
    transform: "translate(95.552 14.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5771",
    "data-name": "Path 5771",
    d: "M90.255,358.08l-4.047,2.7-1.8,3.6-4.5,1.349-19.562,1.938,4.72-5.535,14.42-1.462,1.211-1.911Z",
    transform: "translate(-60.348 -358.08)",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4203",
    "data-name": "Group 4203",
    transform: "translate(34.285 39.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5772",
    "data-name": "Path 5772",
    d: "M31.791,369.686l40.027,27.826s-17.086-19.038-13.179-27.826Z",
    transform: "translate(-31.791 -369.686)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4204",
    "data-name": "Group 4204",
    transform: "translate(73.945 66.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5773",
    "data-name": "Path 5773",
    d: "M50.277,382.543l11.714,8.788,138.637,5.37S75.172,390.841,50.277,382.543Z",
    transform: "translate(-50.277 -382.543)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4205",
    "data-name": "Group 4205",
    transform: "translate(47.252 79.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5774",
    "data-name": "Path 5774",
    d: "M37.835,398.159c.039-.755,37.882,3.894,84.454,11.892s85.175-2.708,85.212-3.463c-.094,1.858-38.218,2.916-84.45-11.894S37.929,396.3,37.835,398.159Z",
    transform: "translate(-37.835 -388.56)",
    fill: "#e7f8fd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5775",
    "data-name": "Path 5775",
    d: "M258.826,403.411c0-.974-44.588,2.583-99.582,9.886s-99.582-8.91-99.582-9.886c0-.481,11.143,3.282,29.167,2.257,18.021-.5,42.917-5.79,70.415-12.141s52.393-6.7,70.415-2.253C247.679,395.19,258.826,403.894,258.826,403.411Z",
    transform: "translate(34.419 -309.195)",
    fill: "#e7f8fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4207",
    "data-name": "Group 4207",
    transform: "translate(114.976 78.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M69.4,400.68c-.034-.7,25.509.665,57.113,4.462s56.476-9.107,56.442-9.809c-.017-.35-6.245,2.669-16.554,2.409-10.292.127-24.664-3.023-40.559-6.874s-30.1-3.431-40.224.264C75.476,394.442,69.419,401.028,69.4,400.68Z",
    transform: "translate(-69.402 -388.168)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4208",
    "data-name": "Group 4208",
    transform: "translate(231.959 88.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M123.929,397.421c.026-.363,10.006,1.6,22.244,5.093s22.683-1.875,22.709-2.236a16.7,16.7,0,0,1-6.636.416c-4.055-.444-9.549-2.763-15.608-5.514s-11.665-3.24-15.84-1.845A19.069,19.069,0,0,0,123.929,397.421Z",
    transform: "translate(-123.929 -392.58)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    transform: "translate(79.66 90.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M52.941,398.442c.024-.36,10,1.6,22.244,5.1s22.684-1.877,22.709-2.238a16.61,16.61,0,0,1-6.636.421c-4.057-.444-9.551-2.763-15.608-5.518s-11.667-3.235-15.84-1.843A19.056,19.056,0,0,0,52.941,398.442Z",
    transform: "translate(-52.941 -393.604)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3116",
    "data-name": "Rectangle 3116",
    width: 14.926,
    height: 14.926,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 433.166, 408.25)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5779",
    "data-name": "Path 5779",
    d: "M137.261,44.481a6.881,6.881,0,1,1-6.881-6.881A6.824,6.824,0,0,1,137.261,44.481Z",
    transform: "translate(452.383 330.467)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5780",
    "data-name": "Path 5780",
    d: "M10.868,16.84,15.765,0,0,5.733Z",
    transform: "translate(651.565 436.231) rotate(-82)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyShipList);
export default __webpack_public_path__ + "static/media/empty-ship-list.1e89fd4f.svg";
export { ForwardRef as ReactComponent };